export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11402.1a6257ba.jpg";